import styled from 'styled-components';

interface SegmentProps {
  active: boolean;
}

interface ProgressBarFillProps {
  progress: number;
}

interface LogoContainerProps {
  progress: number;
}

export const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin-top: 100px;
  margin-bottom: 40px;

  @media (max-width: 800px) {
    height: 50px;
  }
`;

export const ProgressBarBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 50px;
  background-color: ${({ theme }) => theme.colors.neutral200};
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  border: ${({ theme }) => `3px solid ${theme.colors.neutral400}`};
  @media (max-width: 800px) {
    height: 35px;
  }
`;

export const ProgressBarFill = styled.div<ProgressBarFillProps>`
  position: absolute;
  height: 50px;
  background-color: #3bf3ff;
  border-radius: 10px;
  /* transition: width 0.1s ease; */
  width: ${({ progress }) => `${progress}%`};
  border: ${({ theme }) => `3px solid #007d85`};
  @media (max-width: 800px) {
    height: 35px;
  }
`;

export const Segment = styled.div<SegmentProps>`
  position: relative;
  height: 50px;
  flex: 1;
  background-color: transparent;

  &:last-child {
    transform: translate(-100%, 0);
  }
`;

export const SegmentLabel = styled.div<{ index: number }>`
  position: absolute;
  top: -35px;
  text-align: center;
  color: #007d85;
  transform: translate(-50%, 0);

  ${({ index }) => index === 0 && `transform: translate(0, 0);`}
  ${({ index }) => index === 7 && `transform: translate(-100%, 0);`}
`;

export const SegmentMarker = styled.div`
  position: absolute;
  top: -4px;
  width: 1px;
  height: 80px;
  background-color: ${({ theme }) => theme.colors.neutral400};

  @media (max-width: 800px) {
    height: 45px;
  }
`;

export const LogoContainer = styled.div<LogoContainerProps>`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: ${({ progress }) => `calc(${progress}% - 50px)`};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background-color: #3bf3ff;
  border-radius: 24px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  /* transition: left 0.1s ease; */
  border: 15px solid #21a2b3;

  @media (max-width: 800px) {
    left: ${({ progress }) => `calc(${progress}% - 25px)`};
    width: 50px;
    height: 50px;
    border-radius: 12px;
    border: 5px solid #21a2b3;
  }
`;

export const segments = [
  { label: '0', labelMobile: '0', value: 0 },
  { label: '100', labelMobile: '100', value: 100 },
  { label: '250', labelMobile: '250', value: 250 },
  { label: '500', labelMobile: '500', value: 500 },
  { label: '1,000', labelMobile: '1K', value: 1000 },
  { label: '5,000', labelMobile: '5K', value: 5000 },
  { label: '25,000', labelMobile: '15K', value: 25000 },
  { label: '50,000', labelMobile: '50K', value: 50000 }
];

export const EarnBetInputBox = styled.div`
  padding: 30px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.neutral400};
  background-color: ${({ theme }) => theme.colors.neutral100};
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  margin-bottom: 40px;
  width: 100%;
`;

export const EarnBetInputBox2 = styled.div`
  padding: 30px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #73ffde;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  margin-bottom: 40px;
  width: 100%;
  gap: 15px;
  @media (max-width: 800px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const EarnBetInputBox3 = styled.div`
  padding: 30px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #59f7ff;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  margin-bottom: 40px;
  width: 100%;
  gap: 15px;

  @media (max-width: 800px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const EarnBetInput = styled.input`
  font-size: 60px;
  padding: 0;
  background: none;
  border: none;
  color: #063549;
  font-weight: 500;
  width: 100%;

  @media (max-width: 800px) {
    font-size: 40px;
  }
`;

export const EarnBetHalfAmount = styled.div`
  font-size: 60px;
  padding: 0;
  background: none;
  border: none;
  color: #063549;
  font-weight: 500;
  width: 100%;

  @media (max-width: 800px) {
    font-size: 40px;
  }
`;

export const EarnBet50Percent = styled.div`
  font-size: 25px;
  padding: 2px 10px;
  color: #fff;
  font-weight: 500;
  background: #063549;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  border-radius: 10px;
  display: inline-flex;
  margin-top: 5px;
`;
